/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SourceReferenceSystem {
    EPSG_25833 = 'EPSG_25833',
    EPSG_4326 = 'EPSG_4326',
}
